import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.reduce.js";
import { useReducer as t, useEffect as e, useRef as r, useState as o, useCallback as n } from "react";

function s() {
  return (s = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var o in r) {
        Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var c = function c(t, e) {
  if (!t.includes(e)) throw new Error("'".concat(e, "' not found. It must be provided in initialState as a property key."));
},
    a = "production" !== process.env.NODE_ENV ? Symbol("UPDATE_STATE") : Symbol(),
    l = function l(_l, u) {
  var i = Object.keys(u);
  var p = u,
      d = null;
  var f = {};
  i.forEach(function (t) {
    f[t] = new Set();
  });

  var E = function E(t, e) {
    return e.type === a ? e.r ? e.r(t) : e.e : _l(t, e);
  },
      S = function S(t, e) {
    "production" !== process.env.NODE_ENV && c(i, t);

    var r = function r(_r) {
      return s({}, _r, _defineProperty({}, t, (o = _r[t], n = e, "function" == typeof n ? n(o) : n)));
      var o, n;
    };

    if (d) d({
      type: a,
      r: r
    });else {
      p = r(p);
      var _e = p[t];
      f[t].forEach(function (t) {
        return t(_e);
      });
    }
  },
      b = function b(t, e) {
    i.forEach(function (r) {
      var o = e[r];
      t[r] !== o && f[r].forEach(function (t) {
        return t(o);
      });
    });
  };

  return {
    useGlobalStateProvider: function useGlobalStateProvider() {
      var _t = t(E, p),
          _t2 = _slicedToArray(_t, 2),
          o = _t2[0],
          n = _t2[1];

      e(function () {
        if (d) throw new Error("Only one global state provider is allowed");
        return d = n, n({
          type: a,
          e: p
        }), function () {
          d = null;
        };
      }, []);
      var s = r(o);
      b(s.current, o), s.current = o, e(function () {
        p = o;
      }, [o]);
    },
    useGlobalState: function useGlobalState(t) {
      "production" !== process.env.NODE_ENV && c(i, t);

      var _o = o(p[t]),
          _o2 = _slicedToArray(_o, 2),
          r = _o2[0],
          s = _o2[1];

      return e(function () {
        return f[t].add(s), s(p[t]), function () {
          f[t].delete(s);
        };
      }, [t]), [r, n(function (e) {
        return S(t, e);
      }, [t])];
    },
    getGlobalState: function getGlobalState(t) {
      return "production" !== process.env.NODE_ENV && c(i, t), p[t];
    },
    setGlobalState: S,
    getState: function getState() {
      return p;
    },
    setState: function setState(t) {
      if (d) d({
        type: a,
        e: t
      });else {
        var _e2 = p;
        p = t, b(_e2, p);
      }
    },
    dispatch: function dispatch(t) {
      if (d) d(t);else {
        var _e3 = p;
        p = _l(p, t), b(_e3, p);
      }
      return t;
    }
  };
},
    u = function u(t) {
  return l(function (t, e) {
    return t;
  }, t);
},
    i = function i(t) {
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t(void 0, {
    type: void 0
  });
  var r = arguments.length > 2 ? arguments[2] : undefined;
  return r ? r(i)(t, e) : l(t, e);
},
    p = function p() {
  if (!window.__REDUX_DEVTOOLS_EXTENSION__) return function (t) {
    return t;
  };

  var _ref = function () {
    var t, e;
    return {
      before: function before(r) {
        return function (o, n, c) {
          if (t = o, e = n, c) return c(r)(o, n);
          var a = r(o, n);
          return s({}, a, {
            useGlobalState: function useGlobalState(t) {
              var _a$useGlobalState = a.useGlobalState(t),
                  _a$useGlobalState2 = _slicedToArray(_a$useGlobalState, 1),
                  e = _a$useGlobalState2[0];

              return [e, function () {
                throw new Error("Update is not allowed when using DevTools");
              }];
            }
          });
        };
      },
      after: function after(r) {
        return function (o, n, c) {
          if (c) return c(r)(o, n);
          var a = r(t, e);
          var l = s({}, o(n, {
            type: "@@redux/INIT"
          }), e);
          var u = [];
          return s({}, a, {
            getState: function getState() {
              return l;
            },
            dispatch: function dispatch(t) {
              return l = o(l, t), a.setState(l.computedStates[l.currentStateIndex].state), u.forEach(function (t) {
                return t();
              }), t;
            },
            subscribe: function subscribe(t) {
              return u.push(t), function () {
                var e = u.indexOf(t);
                u.splice(e, 1);
              };
            }
          });
        };
      }
    };
  }(),
      t = _ref.before,
      e = _ref.after;

  return function () {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    return t.reduce(function (t, e) {
      return function () {
        return t(e.apply(void 0, arguments));
      };
    });
  }(t, window.__REDUX_DEVTOOLS_EXTENSION__(), e);
};

export { u as createGlobalState, i as createStore, p as reduxDevToolsExt };